import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianCurrency'
})
export class IndianCurrencyPipe implements PipeTransform {
  transform(value: number | string, decimals: number = 2): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(numValue)) {
      return '';
    }

    // Split number into integer and decimal parts
    const parts = numValue.toFixed(decimals).split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];

    // Handle negative numbers
    const isNegative = integerPart.startsWith('-');
    if (isNegative) {
      integerPart = integerPart.substring(1);
    }

    // Apply Indian number format
    // First, take the last 3 digits
    let result = '';
    if (integerPart.length > 3) {
      result = integerPart.substring(integerPart.length - 3);
      integerPart = integerPart.substring(0, integerPart.length - 3);
      
      // Then add commas every 2 digits
      while (integerPart.length > 2) {
        result = integerPart.substring(integerPart.length - 2) + ',' + result;
        integerPart = integerPart.substring(0, integerPart.length - 2);
      }
      
      if (integerPart.length > 0) {
        result = integerPart + ',' + result;
      }
    } else {
      result = integerPart;
    }

    // Add decimal part
    if (decimalPart) {
      result = result + '.' + decimalPart;
    }

    // Add negative sign back
    if (isNegative) {
      result = '-' + result;
    }

    return result;
  }
}
